import Kurikulum from '../../views/Kurikulum/Kurikulum.view';

export default Kurikulum;
